import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {AddAdminDialogComponent} from './add.admin.dialog.component';

const routes = [{path: 'admindialog', component: AddAdminDialogComponent}];

@NgModule({
  declarations: [AddAdminDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [AddAdminDialogComponent]
})

export class AddAdminModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/admin/add.admin.dialog.module.ts